import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'evaluate-question-edit',
  async created () {
    this.search()
    this.$store.dispatch('USERTYPE_ALL_GET', {})
    this.getNormalQuestions()
    this.getPersonnelQuestions()
    this.getBusinessQuestions()
  },
  data () {
    return {
      title: '',
      userType: null,
      normalQuestions: [],
      selectedNormalQuestion: null,
      personnelQuestions: [],
      selectedPersonnelQuestion: null,
      businessQuestions: [],
      selectedBusinessQuestion: null,
      isOwnNormalQuestion: false,
      isOwnPersonnelQuestion: false,
      isOwnBusinessQuestion: false,
      evaluateNormalShopMaster: 1,
      evaluateNormalAnswerUserTypeAllCheck: false,
      evaluateNormalAnswerUserTypeIds: [],
      evaluatePersonnelShopMaster: 1,
      evaluatePersonnelAnswerUserTypeAllCheck: false,
      evaluatePersonnelAnswerUserTypeIds: [],
      evaluateBusinessShopMaster: 1,
      evaluateBusinessAnswerUserTypeAllCheck: false,
      evaluateBusinessAnswerUserTypeIds: [],
      notificationStartDate: '',
      answerStartDate: '',
      endDate: '',
      endDateRange: this.answerStartDateFormat < this.endDateFormat,
      joinRestrictionDate: '',
      shopRestrictionDate: '',
      canValidate: true,
      savingFlag: false,
      getDataEndflag: false
    }
  },
  computed: {
    joinRestrictionDateFormat () {
      return DayJs(this.joinRestrictionDate).format('YYYY-MM-DD')
    },
    shopRestrictionDateFormat () {
      return DayJs(this.shopRestrictionDate).format('YYYY-MM-DD')
    },
    notificationStartDateFormat () {
      return DayJs(this.notificationStartDate).format('YYYY-MM-DD')
    },
    answerStartDateFormat () {
      return DayJs(this.answerStartDate).format('YYYY-MM-DD')
    },
    endDateFormat () {
      return DayJs(this.endDate).format('YYYY-MM-DD')
    },
    validation: function () {
      const today = DayJs(new Date()).format('YYYY-MM-DD')
      var v = {
        title: !!this.title,
        userType: !!this.userType,
        notificationStartDate: !!this.notificationStartDate,
        notificationStartDateRange: DayJs(today).isBefore(this.notificationStartDateFormat),
        answerStartDate: !!this.answerStartDate,
        answerStartDateRange: this.notificationStartDateFormat < this.answerStartDateFormat,
        endDate: !!this.endDate,
        endDateRange: this.answerStartDateFormat < this.endDateFormat,
        joinRestrictionDate: !!this.joinRestrictionDate,
        shopRestrictionDate: !!this.shopRestrictionDate,
        evaluateNormalAnswerUserTypeIds: this.evaluateNormalAnswerUserTypeIds.length > 0,
        evaluatePersonnelAnswerUserTypeIds: this.evaluatePersonnelAnswerUserTypeIds.length > 0,
        evaluateBusinessAnswerUserTypeIds: this.evaluateBusinessAnswerUserTypeIds.length > 0,
        notInput: !!this.title && !!this.userType && !!this.joinRestrictionDate &&
        !!this.shopRestrictionDate &&
        !!this.notificationStartDate &&
        DayJs(today).isBefore(this.notificationStartDateFormat) &&
        !!this.answerStartDate &&
        this.notificationStartDateFormat < this.answerStartDateFormat &&
        !!this.endDate &&
        this.answerStartDateFormat < this.endDateFormat
      }
      if (this.evaluateNormalShopMaster === 2) {
        v.notInput = this.evaluateNormalAnswerUserTypeIds.length > 0
      }
      if (this.evaluatePersonnelShopMaster === 2) {
        v.notInput = this.evaluatePersonnelAnswerUserTypeIds.length > 0
      }
      if (this.evaluateBusinessShopMaster === 2) {
        v.notInput = this.evaluateBusinessAnswerUserTypeIds.length > 0
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    userTypes () {
      return this.$store.getters.usertypesAll
    },
    userTypesFiltered () {
      return this.$store.getters.usertypesAll.filter(userType => userType.id !== this.userType)
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async search () {
      let res = await this.$store.dispatch('GET_EVALUATE_QUESTION_DETAIL', { id: this.$route.params.id })
      .catch(err => {
        console.log(err)
        return
      })
      console.log('詳細res', res)
      const question = res.questions.data.attributes
      this.title = question.title
      this.userType = question['target-user-type-id'] ? question['target-user-type-id'].toString() : null  
      this.normalQuestionId = question['evaluate-normal-question-id']
      this.personnelQuestionId = question['evaluate-personal-question-id']
      this.businessQuestionId = question['evaluate-business-question-id']
      this.notificationStartDate = question['notification-start-date']
      this.answerStartDate = question['answer-start-date']
      this.endDate = question['answer-end-date']
      this.shopRestrictionDate = question['shop-restriction-date']
      this.joinRestrictionDate = question['join-restriction-date']
      // 評価者役職の初期化
      if (question['evaluate-normal-answer-user-types'].length === 1 && question['evaluate-normal-answer-user-types'][0]['is_shop_master'] === 1) {
        this.evaluateNormalShopMaster = 1
      } else {
        this.evaluateNormalShopMaster = 2
        this.evaluateNormalAnswerUserTypeIds = question['evaluate-normal-answer-user-types'].map(obj => obj['target_user_type_id'])
        if (question['evaluate-normal-answer-user-types'].length === this.userTypes.length) {
          this.evaluateNormalAnswerUserTypeAllCheck = true
        }
      }
      if (question['evaluate-personal-answer-user-types'].length === 1 && question['evaluate-personal-answer-user-types'][0]['is_shop_master'] === 1) {
        this.evaluatePersonnelShopMaster = 1
      } else {
        this.evaluatePersonnelShopMaster = 2
        this.evaluatePersonnelAnswerUserTypeIds = question['evaluate-personal-answer-user-types'].map(obj => obj['target_user_type_id'])
        if (!question['evaluate-personal-answer-user-types'].length === this.userTypes.length) {
          this.evaluatePersonnelAnswerUserTypeAllCheck = true
        }
      }
      if (question['evaluate-business-answer-user-types'].length === 1 && question['evaluate-business-answer-user-types'][0]['is_shop_master'] === 1) {
        this.evaluateBusinessShopMaster = 1
      } else {
        this.evaluateBusinessShopMaster = 2
        this.evaluateBusinessAnswerUserTypeIds = question['evaluate-business-answer-user-types'].map(obj => obj['target_user_type_id'])
        if (question['evaluate-business-answer-user-types'].length === this.userTypes.length) {
          this.evaluateBusinessAnswerUserTypeAllCheck = true
        }
      }
      this.isOwnNormalQuestion = question['is-own-normal-question']
      this.isOwnPersonnelQuestion = question['is-own-personal-question']
      this.isOwnBusinessQuestion = question['is-own-business-question']
      this.getDataEndflag = true
      this.selectedNormalQuestion = question['evaluate-normal-question-id']
      this.selectedPersonnelQuestion = question['evaluate-personal-question-id']
      this.selectedBusinessQuestion = question['evaluate-business-question-id']
    },
    async getNormalQuestions () {
      let data = {}
      await this.$store.dispatch('GET_NORMAL_QUESTION_ALL', { data })
      .then(res => {
        this.normalQuestions = res.questions
      })
      .catch(err => {
        console.log(err)
        return
      })
    },
    async getPersonnelQuestions () {
      let data = {}
      await this.$store.dispatch('GET_PERSONNEL_QUESTION_ALL', { data })
      .then(res => {
        this.personnelQuestions = res.questions
      })
      .catch(err => {
        console.log(err)
        return
      })
    },
    async getBusinessQuestions () {
      let data = {}
      await this.$store.dispatch('GET_BUSINESS_QUESTION_ALL', { data })
      .then(res => {
        this.businessQuestions = res.questions
      })
      .catch(err => {
        console.log(err)
        return
      })
    },
    onChangeNotificationStartDate: function () {
      if (this.notificationStartDate) {
        this.joinRestrictionDate = DayJs(this.notificationStartDateFormat).subtract(2, 'month')
        this.shopRestrictionDate = DayJs(this.notificationStartDateFormat).subtract(1, 'month')
      } else {
        this.joinRestrictionDate = ''
        this.shopRestrictionDate = ''
      }
    },
    async onClickSave () {
      if (this.savingFlag) return false
      this.savingFlag = true
      await this.$store.dispatch('EVALUATE_QUESTION_UPDATE', {
        id: this.$route.params.id,
        data: {
          title: this.title,
          target_user_type_id: this.userType,
          evaluate_normal_question_id: this.selectedNormalQuestion,
          evaluate_personal_question_id: this.selectedPersonnelQuestion,
          evaluate_business_question_id: this.evaluate_business_question_id,
          is_own_normal_question: this.isOwnNormalQuestion,
          is_own_personal_question: this.isOwnPersonnelQuestion,
          is_own_business_question: this.isOwnBusinessQuestion,
          notification_start_date: this.notificationStartDateFormat,
          answer_start_date: this.answerStartDateFormat,
          answer_end_date: this.endDateFormat,
          join_restriction_date: this.joinRestrictionDateFormat,
          shop_restriction_date: this.shopRestrictionDateFormat,
          evaluate_normal_shop_master: this.evaluateNormalShopMaster,
          evaluate_normal_answer_user_type_ids: this.evaluateNormalAnswerUserTypeIds,
          evaluate_personal_shop_master: this.evaluatePersonnelShopMaster,
          evaluate_personal_answer_user_type_ids: this.evaluatePersonnelAnswerUserTypeIds,
          evaluate_business_shop_master: this.evaluateBusinessShopMaster,
          evaluate_business_answer_user_type_ids: this.evaluateBusinessAnswerUserTypeIds
        }
      })
      .catch(err => {
        console.log(err)
        return
      })
      this.$router.push('/evaluate_question_list')
    },
    getTypeName (userTypeId) {
      const userType = this.$store.getters.usertypesAll.find(userType => userType.id === userTypeId)
      return userType ? userType.attributes['user-type-name'] : ''
    },
    onClickCancel: function () {
      this.$router.push('/evaluate_question_list')
    },
    evaluateNormalAnswerUserTypeAllChecked: function () {
      this.evaluateNormalAnswerUserTypeIds = this.evaluateNormalAnswerUserTypeAllCheck ? [...this.userTypes.map((userType) => userType.id)] : []
    },
    evaluatePersonnelAnswerUserTypeAllChecked: function () {
      this.evaluatePersonnelAnswerUserTypeIds = this.evaluatePersonnelAnswerUserTypeAllCheck ? [...this.userTypes.map((userType) => userType.id)] : []
    },
    evaluateBusinessAnswerUserTypeAllChecked: function () {
      this.evaluateBusinessAnswerUserTypeIds = this.evaluateBusinessAnswerUserTypeAllCheck ? [...this.userTypes.map((userType) => userType.id)] : []
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/evaluate-question-edit.js